import getAuthData from './mini/getAuthData';
import { ChatMessageType } from '../const/chatMessageType';
import { mergeProgressiveMessages } from '../../../alan_btn/src/textChat/helpers/mergeProgressiveMessages';
import _ from 'lodash';
import { EventEmitter } from 'events';

function getProjectId(key) {
    if (key) {
        return key.substr(0, key.indexOf('/'));
    }
    return key;
}

class TestCases extends EventEmitter {
    constructor(project, options) {
        super();
        this.project = project;

        this.getSettings = () => {
            return this.dialog.getSettings();
        };

        this.textListener = (r) => {
            const receivedData = { ...(r.ctx ? r.ctx : {}), ...r };
            log(`${printTime()} - received data`, receivedData);
            log(`${printTime()} - received from server: ${getRequestId(receivedData)} ${r?.text || ''} ${r.ctx?.final}`);
            this.lastResponseTs = nowMs();
            const node = this.reqIdToNode[getRequestId(receivedData)];
            if (node) {
                if (receivedData.ctx?.final === false) {
                    this.isProgressiveMsg = true;
                }

                if (node.response?.length === 0) {
                    node.response.push(receivedData);
                } else {
                    if (this.isProgressiveMsg) {
                        mergeProgressiveMessages(node.response, 0, receivedData);
                        if (receivedData.ctx) {
                            if (!node.response[0].ctx) {
                                node.response[0].ctx = {};
                            }
                            node.response[0].ctx.final = receivedData.ctx?.final !== undefined ? receivedData.ctx?.final : false;
                            node.response[0].ctx.inspectURL = receivedData.ctx?.inspectURL !== undefined ? receivedData.ctx?.inspectURL : undefined;
                        }
                    } else {
                        node.response.push(receivedData);
                    }
                }

                if (this.isProgressiveMsg) {
                    if (receivedData.ctx?.final === true) {
                        clearTimeout(this.nextChainCbDelayed);
                        log(printTime() + ' - go to next node cb');
                        this.nextChainCb();
                    }
                } else {
                    log(printTime() + ' - go to next node cb');
                    clearTimeout(this.nextChainCbDelayed);
                    this.nextChainCb();
                }
            }
            if (options.onText) {
                options.onText({ ...receivedData, type: ChatMessageType.Text });
            }
        };

        this.peerAuthorizedListener = (r) => {
            if (options.onPeerAuthorized) {
                options.onPeerAuthorized({ status: r, type: ChatMessageType.ConnectionState });
            }
        };

        this.peerVisualListener = (r) => {
            if (options.onPeerVisual) {
                options.onPeerVisual({ data: r, type: ChatMessageType.VisualState });
            }
        };

        this.peerDisconnectListener = (r) => {
            if (options.onPeerDisconnect) {
                options.onPeerDisconnect({ ...r, type: ChatMessageType.ConnectionState });
            }
        };

        this.parsedListener = (r) => {
            log(printTime() + " - parsed: " + JSON.stringify(r));
            this.lastResponseTs = nowMs();
            const node = this.reqIdToNode[getRequestId(r)];
            if (node) {
                node.meta = r.pLoc ? { pLoc: r.pLoc } : {};
                this.afterListener(node);
            }
            if (options.onParsed) {
                options.onParsed({ ...r, type: ChatMessageType.Text, my: true, final: true });
            }
        };
        this.commandListener = (r) => {
            log("command: " + JSON.stringify(r));
            this.lastResponseTs = nowMs();
            log(`this.lastResponseTs: ${this.lastResponseTs}`);
            if (r.ctx) {
                const node = this.reqIdToNode[r.ctx.reqId];
                if (node) {
                    node.response.push(r);
                    this.afterListener(node);
                }
            }
            if (options.onCommand) {
                options.onCommand({ ...r, type: ChatMessageType.Command });
            }
        };

        this.isProgressiveMsg = false;
        this.lastResponseTs = 0;
        this.waitBetweenResponsesMs = 300;
        this.waitBetweenChainsMs = 0;
        this.waitAfterAllNodesMs = 1000;
        this.waitForResponse = 70000;
        this.initConnection();
        this.refreshingNode = null;
        this.off = this.removeListener;
        this.stop = false;
        this.reqIdToNode = {};
        this.callbackSent = false;
        this.nextTasks = [];
        this.currentTask = null;
        this.chainId = null;
        this.finalCallback = null;
        this.nextChainCb = null;
        this.nextChainCbDelayed = null;

    }

    resetContext() {
        return new Promise((resolve, reject) => {
            this.dialog.call("clearDialogContext", {}, (e) => {
                if (e) {
                    console.error(e);
                    reject();
                }
                resolve();
            });
        });
    }

    initConnection() {
        this.dialog = alan.projectTest(this.project, getAuthData(getProjectId(this.project), {}), null, null,
            { platform: 'alantests', platformVersion: process.env.VERSION });
        this.dialog.on('text', this.textListener);
        this.dialog.on('parsed', this.parsedListener);
        this.dialog.on('connectStatus', this.peerAuthorizedListener);
        this.dialog.on('peerVisual', this.peerVisualListener);
        this.dialog.on('peerDisconnect', this.peerDisconnectListener);

        alanAudio.on('command', this.commandListener);
    }

    afterListener() {
        if (this.callbackSent) {
            this.callbackSent = false;
            setTimeout(this.finalCallback, this.waitAfterAllNodesMs);
        }
    }

    unsubscribeListeners() {
        log('unsubscribe');
        alanAudio.off('command', this.commandListener);
    }

    close() {
        this.unsubscribeListeners();
        log('close');
        this.dialog.off('text', this.textListener);
        this.dialog.off('parsed', this.parsedListener);
        this.dialog.close();
    }

    askAlan(textToAsk, node) {
        log(printTime() + ' - request sent: ' + textToAsk);
        delete this.reqIdToNode[node.reqId];
        node.reqId = null;
        this.dialog.call("text", { text: textToAsk }, (e, r) => {
            log(printTime() + ' - requestId recieved for request: ' + textToAsk);
            if (e) {
                console.error(e);
            } else if (r && r.reqId) {
                if (node.reqId) {
                    delete this.reqIdToNode[node.reqId];
                }
                node.reqId = r.reqId;
                this.reqIdToNode[r.reqId] = node;
                node.response = [];
            }
        });
    }

    emitRefreshEndEvent() {
        this.emit('nodeRefreshEnd', { node: this.refreshingNode, chainId: this.chainId });
        this.refreshingNode = null;
    }

    fillResponses(chainId, phrases, node, resPhrasesCb) {
        log(printTime() + ' - start asking');
        this.reset(chainId);
        this.finalCallback = () => {
            log(printTime() + ' - final cb executed');
            this.callbackSent = true;
            resPhrasesCb(phrases);
        };
        const idToNode = fillChildren(phrases);
        const chains = getPathsOfNode(idToNode, node);
        this.fillResponsesOfChains(chains);
    }

    fillResponsesOfChains(chains) {
        if (!chains.length) {
            return this.finalCallback ? this.finalCallback() : undefined;
        }
        const currentChain = chains[0];
        this.fillResponsesOfChain(currentChain, () => {
            const restChain = chains.slice(1);
            this.fillResponsesOfChains(restChain);
        });
    }

    fillResponsesOfChain(chain, proceedNextChainCb) {
        if (this.stop) {
            return;
        }
        // if (this.refreshingNode && this.refreshingNode.reqId == null) {
        //     setTimeout(() => this.fillResponsesOfChain(chain, proceedNextChainCb), 1);
        //     return;
        // }
        if (this.refreshingNode) {
            this.emitRefreshEndEvent();
        }
        if (chain.length === 0) {
            const now = nowMs();
            const needToWait = this.lastResponseTs + this.waitBetweenChainsMs - now;
            if (needToWait > 0) {
                setTimeout(() => this.finalCallback, needToWait);
                return;
            }
            return this.finalCallback ? this.finalCallback() : undefined;
        }
        const node = chain[0];
        if (node.request && node.request.visualState) {
            this.setVisual(node.request.visualState);
            setTimeout(() => this.fillResponsesOfChain(chain.slice(1), proceedNextChainCb), this.waitBetweenResponsesMs);
            return;
        }
        const nodeCopy = Object.assign({}, node);
        this.emit('nodeRefreshStart', nodeCopy);
        this.refreshingNode = node;
        this.askAlan(node.request.text, node);

        this.nextChainCb = () => {
            log(printTime() + ' - next node cb executed');
            this.fillResponsesOfChain(chain.slice(1), proceedNextChainCb);
        };
        this.nextChainCbDelayed = setTimeout(() => {
            this.nextChainCb();
            this.nextChainCbDelayed = null;
        }, this.waitForResponse);
    }

    reset(chainId) {
        this.chainId = chainId;
        this.stop = false;
        this.finalCallback = null;
        this.callbackSent = false;
        this.isProgressiveMsg = false;
    }

    setVisual(state) {
        this.lastResponseTs = nowMs();
        this.dialog.setVisual(state);
    }

    stopFillResponses() {
        this.stop = true;
    }
}

function fillChildren(arr) {
    const idToNode = {};
    const roots = [];
    arr.forEach(e => idToNode[e.id] = e);
    arr.forEach(e => {
        if (e.parentId) {
            const parent = idToNode[e.parentId];
            if (parent) {
                if (!parent.children) {
                    parent.children = [];
                }
                if (!parent.children.includes(e)) {
                    parent.children.push(e);
                }
            }
        } else {
            roots.push(e);
        }
    });
    // return {roots: roots, idToNode: idToNode};
    return idToNode;
}

function getPathsOfRoot(root) {
    function iter(o, p) {
        let children = o.children;
        if (children && children.length) {
            return children.forEach(function (e) {
                iter(e, p.concat(e));
            });
        }
        result.push(p);
    }
    var result = [];
    iter(root, [root]);
    return result;
}

function getParentChain(idToNode, node) {
    let result = [];
    let n = 0;
    while (n++ < 1000) {
        if (node && !node.parentId) {
            return result;
        }
        node = idToNode[node.parentId];
        if (node) {
            result.unshift(node);
        } else {
            return [];
        }
    }
}

function getPathsOfNode(idToNode, node) {
    const parentChain = getParentChain(idToNode, node);
    const restChains = getPathsOfRoot(node);
    return restChains.map(e => parentChain.concat(e));
}

function nowMs() {
    return new Date().getTime();
}

function formatNum(num, numOfChars) {
    let numStr = "" + num;
    for (let i = numStr.length; i < numOfChars; i++) {
        numStr = 0 + numStr;
    }
    return numStr;
}

function printTime() {
    const date = new Date();
    return formatNum(date.getHours(), 2) + ':' +
        formatNum(date.getMinutes(), 2) + ':' +
        formatNum(date.getSeconds(), 2) + '.' +
        formatNum(date.getMilliseconds(), 3);
}

function getRequestId(msg) {
    return msg?.reqId || msg?.ctx?.reqId;
}

function log(msg) {
    // console.log(msg);
}
export default TestCases;